import React from "react";
import { Text } from "./Text";
import styled from "styled-components";
import Theme from "../../../styles/Theme/Theme";
import { Flex } from "antd";

const SimpleTooltipWrapper = styled.div`
  position: absolute;
  background-color: ${Theme.color["white"]};
  z-index: 3;
  display: ${(props) => props.display};
  width: 150px;
  height: 50px;
  padding: ${Theme.spacing['s03']};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: ${Theme.radius["md"]};
`;

const SimpleTooltip = ({ text, value, reference, display }) => {
  return (
    <SimpleTooltipWrapper ref={reference} display={display}>
      <Flex vertical={true} gap={Theme.spacing['s02']} justify={"center"} align="center">
        {text ? (
          <Text $fontColor="black" $fontSize="text_md" $weight="">
            {text}
          </Text>
        ) : null}
        {value ? (
          <Text $fontColor="black" $fontSize="text_md" $weight="">
            {value}
          </Text>
        ) : null}
      </Flex>
    </SimpleTooltipWrapper>
  );
};

export default SimpleTooltip;
